import React from 'react';

const SIZES = { xs: 20, sm: 36, md: 48, lg: 80, xl: 96 };
const TEXT_SIZES = { xs: 'text-[8px]', sm: 'text-xs', md: 'text-sm', lg: 'text-xl', xl: 'text-2xl' };

export function Avatar({ name, photoUrl, size = 'md', className = '' }) {
    const px = SIZES[size] || SIZES.md;
    const src = photoUrl ? `/api/photos/${photoUrl}` : null;
    const textSize = TEXT_SIZES[size] || TEXT_SIZES.md;

    const initials = (name || '?')
        .split(' ')
        .map((w) => w[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();

    return (
        <div
            className={`rounded-full inline-flex items-center justify-center overflow-hidden bg-accent-100 dark:bg-accent-900/30 flex-shrink-0 ${className}`}
            style={{ width: px, height: px, maxWidth: '100%' }}
        >
            {src ? (
                <img src={src} alt={name} className="w-full h-full object-cover" />
            ) : (
                <span className={`font-semibold text-accent-600 dark:text-accent-400 ${textSize}`}>
                    {initials}
                </span>
            )}
        </div>
    );
}

export default Avatar;
